export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10785.efe096a1.jpg";